import React from 'react';
import { Form, Input} from 'antd';

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
};

class FormInputText extends React.Component {
    render(){
        const field = this.props.field ? this.props.field : 'meta_title';
        const label = this.props.label ? this.props.label : field;
        const required = this.props.required === undefined ? true : this.props.required;
        const direction = this.props.direction ? this.props.direction : 'rtl';
        return (
            <Form.Item
                {...formItemLayout}
                label={label}
                style={{direction: direction}}
                colon={false}>
                {this.props.getFieldDecorator(field, {
                    initialValue: this.props.initialValue ? this.props.initialValue : '',
                    rules: [{
                        required: required, message: 'فیلد را پر کنید',
                    }],
                })(
                    <Input onChange={(e)=>{this.props.update(e.target.value, field)}}/>
                )}
            </Form.Item>

        );
    }
}

export default FormInputText;


// WEBPACK FOOTER //
// ./src/containers/Pages/Partials/FormInputText.js